// Single source of truth for the "Bike insurance" nav dropdown (desktop bar
// and mobile drawer both render from this same array) and for the matching
// block of links at the top of the footer's FEATURES column.
//
// `overview: true` marks the one entry the dropdown renders as a visually
// separated first row. Appending a future page is a one-line addition here;
// nothing else has to change.
export const BIKE_INSURANCE_LINKS = [
  { to: '/bike-insurance', label: 'Bike insurance', overview: true },
  { to: '/what-we-cover', label: 'What we cover' },
  { to: '/bike-theft-insurance', label: 'Bike theft insurance' },
  { to: '/electric-bike-insurance', label: 'Electric bike insurance' },
  { to: '/road-bike-insurance', label: 'Road bike insurance' },
  { to: '/mountain-bike-insurance', label: 'Mountain bike insurance' },
  { to: '/cargo-bike-insurance', label: 'Cargo bike insurance' },
  { to: '/commuter-cycle-insurance', label: 'Commuter cycle insurance' },
  { to: '/triathlon-cycle-insurance', label: 'Triathlon bike insurance' },
]
